export interface PlacePrediction {
  place_id: string;
  description: string;
  structured_formatting: {
    main_text: string;
    secondary_text: string;
  };
}

export async function getPlacePredictions(
  input: string
): Promise<PlacePrediction[]> {
  try {
    const response = await fetch("/api/places/autocomplete", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        input,
      }),
    });

    const data = await response.json();
    if (data.status === "OK") {
      return data.predictions || [];
    }
    console.warn("Places API response:", data);
    return [];
  } catch (error) {
    console.error("Error fetching predictions:", error);
    return [];
  }
}
